﻿import { GuiListGeneric } from "../GuiListGeneric";

export class GuiListBehaeltertyp extends GuiListGeneric {

    constructor() {
        super("Behaeltertyp");
    }
}

